<div class="forbidden-page">
    <div class="forbidden-page__image">
        <img src="assets/icons/common/error.svg" alt="Error">
    </div>
    <div class="forbidden-page__primary-text">
        The page that you have tried cannot be accessed.
    </div>
    <div class="forbidden-page__secondary-text">
        {{supportMessage()}}
    </div>
</div>
